import { Auth } from 'aws-amplify';
import { useApolloClient } from '@apollo/react-hooks';

export default () => {
    const client = useApolloClient();

    const logout = async () => {
        try {
            await Auth.signOut();
            await client.clearStore();
        } catch (error) {
            console.error('Error logging out: ', error);
        }
        return true;
    };
    return logout;
};
